import React, { FC } from 'react';
import TableSimple from 'src/components/TableSimple';
import { TableColumnType } from 'src/types/table';
import { OrderExpeditionPackageProductType } from 'src/types/orderExpeditionPackage';

export type EditKeysType = 'QUANTITY' | 'RECEIVED' | 'RESOLUTION';

const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        type: 'number-filter',
    },
    {
        key: 'SKU',
        label: 'SKU',
    },
    {
        key: 'SERIAL_NUMBER',
        label: 'serialNumber',
    },
    {
        key: 'LOT',
        label: 'lot',
    },
    {
        key: 'EXP_DATE',
        label: 'expDate',
    },
    {
        key: 'COUNT',
        label: 'count',
    },
];

export interface ProductsTablePropsType {
    data?: OrderExpeditionPackageProductType[];
}

const ProductsTable: FC<ProductsTablePropsType> = (props) => {
    return (
        <TableSimple
            rowIdKey="ID"
            rows={props.data || []}
            columsLabelPrefix="orderExpeditionPackageDetail.productTable"
            allColumns={allColumns}
            initSort={{ column: 'ID', direction: 'ASC', createIdNumber: true }}
            maxHeight={'unset'}
        />
    );
};

export default ProductsTable;
